import { useSelector, shallowEqual } from 'react-redux';

import useActionCreator from '../../hooks/useActionCreator';
import {
  setError,
  setSuccess,
  getAccount,
  updateAccountInfo,
  updateEmailPreferences,
  saveEmailPreferences,
  saveProfile,
  saveProfileFeedback,
  setAccountDocument,
  setOnboardingComplete,
  setOnboardingCall,
  setUseStripeNonprofitRates,
  setAccountMfa,
  setUserRole,
  updateEmbeddedDonationPages,
  saveEmbeddedDonationPages,
} from './actions';

export const useAccount = () => {
  const accountState = useSelector((state) => state.account, shallowEqual);

  return {
    ...accountState,
    setError: useActionCreator(setError),
    setSuccess: useActionCreator(setSuccess),
    getAccount: useActionCreator(getAccount),
    updateAccountInfo: useActionCreator(updateAccountInfo),
    updateEmailPreferences: useActionCreator(updateEmailPreferences),
    saveEmailPreferences: useActionCreator(saveEmailPreferences),
    saveProfile: useActionCreator(saveProfile),
    saveProfileFeedback: useActionCreator(saveProfileFeedback),
    setAccountDocument: useActionCreator(setAccountDocument),
    setOnboardingComplete: useActionCreator(setOnboardingComplete),
    setOnboardingCall: useActionCreator(setOnboardingCall),
    setUseStripeNonprofitRates: useActionCreator(setUseStripeNonprofitRates),
    setAccountMfa: useActionCreator(setAccountMfa),
    setUserRole: useActionCreator(setUserRole),
    updateEmbeddedDonationPages: useActionCreator(updateEmbeddedDonationPages),
    saveEmbeddedDonationPages: useActionCreator(saveEmbeddedDonationPages),
  };
};
